export const calculateProfileCompletion = (user) => {
    if (!user) return { score: 0, missingFields: [] };

    const checkString = (val) => val !== null && val !== undefined && String(val).trim() !== '' && val !== '[]';

    const getArray = (val) => {
        if (!val) return [];
        let data = val;
        if (typeof val === 'string') {
            try {
                data = JSON.parse(val);
            } catch (e) {
                return [];
            }
        }
        return Array.isArray(data) ? data : [];
    };

    let nonDocScore = 0;
    const missingFields = [];

    // 1. Photo (10%)
    const hasPhoto = checkString(user.photo_url) || checkString(user.photo);
    if (hasPhoto) {
        nonDocScore += 10;
    } else {
        missingFields.push('Profile Photo (10%)');
    }

    // 2. Basic Profile Details (10%)
    const hasBasicProfileDetails = checkString(user.phone) || checkString(user.city) || 
                                   checkString(user.nationality) || checkString(user.about_me) || 
                                   checkString(user.gender) || checkString(user.date_of_birth) ||
                                   checkString(user.occupation) || checkString(user.resume_url);
    if (hasBasicProfileDetails) {
        nonDocScore += 10;
    } else {
        missingFields.push('Basic Profile Details (phone, nationality, bio, etc.) (10%)');
    }

    // 3. Education History (10%)
    const hasEducation = getArray(user.education_history).length > 0;
    if (hasEducation) {
        nonDocScore += 10;
    } else {
        missingFields.push('Education History (at least 1 entry) (10%)');
    }

    // 4. Employment History (10%)
    const hasEmployment = getArray(user.employment_history).length > 0;
    if (hasEmployment) {
        nonDocScore += 10;
    } else {
        missingFields.push('Employment History (at least 1 entry) (10%)');
    }

    // 5. Skills (10%)
    const hasSkills = getArray(user.skills).length > 0 && String(user.skills) !== '[]';
    if (hasSkills) {
        nonDocScore += 10;
    } else {
        missingFields.push('Skills (at least 1 entry) (10%)');
    }

    // 6. Certificates (10%)
    const hasCertificates = getArray(user.certificates).length > 0;
    if (hasCertificates) {
        nonDocScore += 10;
    } else {
        missingFields.push('Certificates (at least 1 entry) (10%)');
    }

    // Cap the non-document score at 50%
    const finalNonDocScore = Math.min(nonDocScore, 50);

    // 7. Documents (50% max, 5% per document up to 10 documents)
    const docs = getArray(user.documents);
    const docCount = docs.length;
    const docScore = Math.min(docCount, 10) * 5;

    if (docCount < 10) {
        missingFields.push(`Upload 10 documents (currently ${docCount}/10 uploaded) (${50 - docScore}% remaining)`);
    }

    const totalScore = finalNonDocScore + docScore;

    return { score: totalScore, missingFields };
};
